module.exports = __webpack_public_path__ + "img/instagram-icon.b066fb9c.svg";